<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="5" :sm="24">
              <a-form-item :label="$t('rechargeMenu.rechargePrice')" prop="rechargePrice">
<!--                <a-input v-model="queryParam.rechargePrice" placeholder="请输入充值价格" allow-clear />-->
                <a-input-number :min="0" :step="0.01" :precision="2" v-model="queryParam.rechargePrice" allow-clear :placeholder="$t('rechargeMenu.inputRechargePrice')" style="width: 100%" />
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-form-item :label="$t('rechargeMenu.rechargeDiamond')" prop="rechargeDiamond">
<!--                <a-input v-model="queryParam.rechargeDiamond" placeholder="请输入充值金币" allow-clear />-->
                <a-input-number :min="0" :step="1" v-model="queryParam.rechargeDiamond" allow-clear :placeholder="$t('rechargeMenu.inputRechargeDiamond')" style="width: 100%" />
              </a-form-item>
            </a-col>
<!--            <a-col :md="5" :sm="24">-->
<!--              <a-form-item label="ios内购产品id" prop="productId">-->
<!--                <a-input v-model="queryParam.productId" placeholder="请输入ios内购产品id" allow-clear />-->
<!--              </a-form-item>-->
<!--            </a-col>-->
            <template v-if="advanced">

            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('common.query') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('common.reset') }}</a-button>
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
<!--                  {{ advanced ? '收起' : '展开' }}-->
<!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
<!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"

        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 720 }"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>


        <span slot="isOpen" slot-scope="text, record">
          <a-switch :checkedChildren="$t('common.enable')" :unCheckedChildren="$t('common.disable')" v-model="record.isOpen == 1" @change="changeIsOpen($event,record)"/>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-space :size="8">
            <!-- v-hasPermi="['rechargeMenu:rechargeMenu:edit']" -->
            <a @click="$refs.createForm.handleUpdate(record, undefined)">
              <a-icon type="edit" />{{ $t('common.edit') }}
            </a>
          </a-space>
<!--          <a-divider type="vertical" v-hasPermi="['rechargeMenu:rechargeMenu:remove']" />-->
<!--          <a @click="handleDelete(record)" v-hasPermi="['rechargeMenu:rechargeMenu:remove']">-->
<!--            <a-icon type="delete" />删除-->
<!--          </a>-->
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => $t('table.total', { total })"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
        :rowKey="(record, index) => index + 1"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageRechargeMenu, delRechargeMenu ,changeIsOpen} from '@/api/rechargeMenu/rechargeMenu.js'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'RechargeMenu',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用?      single: true,
      // 非多个禁用?      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        rechargePrice: null,
        rechargeDiamond: null,
        productId: null,
        pageNum: 1,
        pageSize: 10
      },
    }
  },
  filters: {
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('table.index'),
          dataIndex: 'index',
          customRender: (text, record, index) => index + 1,
          width: 80,
          align: 'center'
        },
        {
          title: this.$t('rechargeMenu.rechargePrice'),
          dataIndex: 'rechargePrice',
          width: 120,
          align: 'center'
        },
        {
          title: this.$t('rechargeMenu.status'),
          dataIndex: 'isOpen',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'isOpen' },
        },
        {
          title: this.$t('rechargeMenu.rechargeDiamond'),
          dataIndex: 'rechargeDiamond',
          width: 120,
          align: 'center'
        },
        {
          title: this.$t('rechargeMenu.giveDiamond'),
          dataIndex: 'giveDiamond',
          width: 120,
          align: 'center'
        },
        {
          title: this.$t('common.operation'),
          dataIndex: 'operation',
          width: 180,
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  created () {
    this.getList()
  },
  watch: {
  },
  methods: {
    /** 查询充值菜单列�?*/
    getList () {
      this.loading = true
     pageRechargeMenu(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    changeIsOpen (e,record) {
      record.isOpen = e ? 1 : 0
      changeIsOpen(record).then(response => {
        this.$message.success(
            this.$t('rechargeMenu.operationSuccess')
        )
        return  record.isOpen = e ? 1 : 0
      })
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        rechargePrice: undefined,
        rechargeDiamond: undefined,
        productId: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    // onShowSizeChange 方法已在 tableMixin 中统一处理，无需重复定义
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('rechargeMenu.confirmDelete'),
        content: this.$t('rechargeMenu.confirmDeleteContent') + ids,
        onOk() {
          return delCancel(ids)
            .then(() => {
              that.getList()
              that.$message.success(
                that.$t('common.deleteSuccess'),
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('rechargeMenu.confirmExport'),
        content: this.$t('rechargeMenu.confirmExportContent'),
        onOk () {
          that.download('rechargeMenu/rechargeMenu/export', {
            ...that.queryParam
          }, `${that.$t('rechargeMenu.exportFileName')}_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>

<!--<style scoped lang="less">-->
<!--@import '~@/styles/table-responsive.less';-->
<!--</style>-->
